// @flow
export const COLOR_REPUBLICAN_MIN = '#ffaeae';
export const COLOR_REPUBLICAN_MAX = '#9B0000';
export const COLOR_DEMOCRAT_MIN = '#a5b1f5';
export const COLOR_DEMOCRAT_MAX = '#0E28BA';
export const COLOR_NEUTRAL = '#55145d';

export const CENSUS_TX_MAP = {
  "employed_i": "Population Employed",
  "employedhealthcoverage_i": "Population Employed with Health Coverage",
  "female_votingage_i": "Female Population Voting Age",
  "male_votingage_i": "Male Population Voting Age",
  "population_hshigher_i": "Population Education HS Or Higher",
  "population_nohs_i": "Population Education Less Than High School",
  "publichealthins_i": "Population with Public Health Insurance",
  "race_africanamerican_i": "Population Race African American",
  "race_hispanic_latino_i": "Population Race Hispanic/Latino",
  "totalpopulation_i": "Total Population",
  "unemployedhealthcoverage_i": "Population Unemployed with Health Coverage",
  "vertans_i": "Population Veterans"
};

export const STATES = ["AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS",
  "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH",
  "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"];
export const DECAY = 0.9;
export const YT_API_KEY = 'AIzaSyCZi_6D2Y9L_U5eWQmjm4uhDbvH5Tm8bIQ';
export const PLAYER_STATES = {
  '-1': 'unstarted',
  '0': 'ended',
  '1': 'playing',
  '2': 'paused',
  '3': 'buffering',
  '5': 'video cued',
};
export const VIDEOS = {
  PDebate3: '466E33mxzBs',
  PDebate2: 'FRlI2SQ0Ueg',
  // VPDebate1: 'is8cx0q39bI',
  PDebate1: '855Am6ovK7s',
};
export const API = "http://207.99.28.135:8080";
export const ENDPOINTS = {
  http: `${API}/range`,
  ws: API.replace(/^http/, 'ws'),
  census: `${API}/census`,
};



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/